import MenuIcon from "../../../assets/icon/NewsIcons/HumbergerMenu";
import {useState} from "react";
import {Link} from "react-router-dom";
import Logo from "../../../assets/img/NewsImgs/newLogo.webp"
import {default as Cross} from "../../../assets/icon/NewsIcons/MainAdmin/NewsCross"
import {Menu, MenuButton, MenuItem, MenuItems} from '@headlessui/react'
import {ChevronDownIcon} from '@heroicons/react/20/solid'
const ResponsiveNavbarLeft = ({data}) => {
    const [showBox,
        setShowBox] = useState(false);
    function classNames(...classes) {
        return classes
            .filter(Boolean)
            .join(' ')
    }
    return ( <> <div className="cursor-pointer" onClick={() => setShowBox(!showBox)}>
            <MenuIcon/>
        </div>
        {
        showBox
            ? <div className="customLink">
                    <div
                        className="bg-[#0d2224] w-[90%] h-full z-50  right-0 px-8 py-10 top-0 fixed">
                        <div className="flex justify-between items-center mb-4">
                            <div>
                                <Link to={"/"}>
                                    <img src={Logo} className="w-[60px] "/>
                                </Link>
                            </div>
                            <div>
                                <button className="crossBtn" onClick={() => setShowBox(!showBox)}>
                                    <Cross/>
                                </button>
                            </div>
                        </div>
                        <div className="flex flex-col justify-start items-start">
                        {
                    data?.map((item) => {
                        return (
                            <Menu as="div" className="relative inline-block text-left ">
                                <div>
                                    <a
                                        href={"/archive/" + item.categorySlug}
                                        className="inline-flex w-full justify-center items-center  px-3 my-2  pb-[2px] text-white  font-IRANYekanMedium text-[12px]  ">

{item.categoryName}

                                    </a>

                                </div>

                            </Menu>
                        )})}
                          <Menu as="div" className="relative inline-block text-left ">
                                <div>
                                    <a
                                        href={"/archive/all"}
                                        className="inline-flex w-full justify-center items-center  px-3 my-2  pb-[2px] text-white  font-IRANYekanMedium text-[12px]  ">

آخرین اخبار

                                    </a>

                                </div>

                            </Menu>
                        </div>

                    </div>
                </div>
            : null
    } </>
    )
}

export default ResponsiveNavbarLeft;